<template>
    <div v-if="!loading" class="field">
        <div v-if="!validSchoolCode" class="field is-horizontal">
            <div class="field-label">
                <label v-t="'userProfile.input_school_code'" class="label" />
            </div>
            <div class="field-body">
                <div class="field is-expanded">
                    <div class="field has-addons">
                        <p class="control is-expanded">
                            <input
                                v-model="schoolCode"
                                :placeholder="
                                    $t(
                                        'userProfile.input_school_code_placeholder'
                                    )
                                "
                                class="input"
                                type="text"
                            />
                        </p>
                        <p class="control">
                            <button
                                v-t="'userProfile.validate_school_code'"
                                class="button is-success"
                                @click="joinSchool"
                            />
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="validSchoolCode" class="field is-horizontal">
            <div class="field-body">
                <div class="field">
                    <label v-t="'userProfile.school_name'" class="label" />
                    <div class="control">
                        <div class="control">
                            <input
                                v-model="school.name"
                                class="input is-static"
                                disabled
                                type="text"
                            />
                        </div>
                        <p class="control">
                            <button
                                v-t="'userProfile.leave_school'"
                                class="button is-warning"
                                @click="leaveSchool"
                            />
                        </p>
                    </div>
                </div>
                <div class="field is-hidden">
                    <label class="label">Network</label>
                    <div class="control">
                        <input
                            class="input is-static"
                            disabled
                            type="text"
                            placeholder="Disabled input"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="loader" />
</template>

<script>
import { fetchItem, joinSchool, leaveSchool } from '@/services/API';
import _ from 'underscore';
import Swal from 'sweetalert2';
export default {
    data() {
        return {
            school: {},
            schoolCode: undefined,
            loading: true,
        };
    },
    computed: {
        schoolId() {
            return this.$store.getters.school._id;
        },
        validSchoolCode() {
            return !_.isEmpty(this.school);
        },
        userId() {
            return this.$store.getters.user.owner;
        },
    },
    watch: {
        schoolId: {
            handler: 'fetchSchool',
            immediate: true,
        },
    },
    mounted() {},
    methods: {
        async fetchSchool() {
            this.loading = true;
            if (this.schoolId) {
                let response = await fetchItem('school', this.schoolId);
                this.loading = false;
                this.school = response.data;
            } else {
                this.loading = false;
            }
        },
        async joinSchool() {
            this.loading = true;
            await joinSchool(this.schoolCode)
                .catch()
                .finally(() => {
                    this.loading = false;
                });
            this.$store.dispatch('fetchProfile');
        },
        leaveSchool() {
            Swal.fire({
                title: this.$t('userProfile.leave_my_school_sure'),
                text: this.$t('userProfile.leave_my_school_content_created'),
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.$t('userProfile.leave_school_continue'),
                cancelButtonText: this.$t('userProfile.leave_school_cancel'),
            }).then((result) => {
                if (result.isConfirmed) {
                    this.leave();
                }
            });
        },
        async leave() {
            this.loading = true;
            let error = false;
            await leaveSchool(this.userId)
                .catch((e) => {
                    Swal.fire({
                        title: this.$t('Error.' + e.status),
                        text: this.$t('Error.MY_' + e.data),
                        showCancelButton: false,
                        confirmButtonText: this.$t(
                            'userProfile.leave_school_cancel'
                        ),
                        confirmButtonColor: '#d33',
                    });
                    error = true;
                    return;
                })
                .finally(() => {
                    if (!error) {
                        this.school = {};
                    }
                    this.loading = false;
                });
            this.$store.dispatch('fetchProfile');
        },
    },
};
</script>

<style></style>
